import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography,
  CircularProgress,
  Slide,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import type { ITag } from 'services/api/entities';
import type { TagStore } from 'services/store/tags';
import { TagType } from 'services/api/responses/responseTypes';
import useStyles from './style';

type PropsType = {
  isOpen: boolean;
  isLoading: boolean;
  tagType: TagType;
  tagStore: TagStore;
  selectTag: (tag: ITag) => void;
};

const TagDrawer = (props: PropsType): React.ReactElement => {
  const { isOpen, isLoading, tagType, tagStore, selectTag } = props;

  const classes = useStyles();
  const displayCircularProgress = () => (
    <div
      className={classes.loadingContent}
      data-testid="tags-loading-indicator"
    >
      <CircularProgress color="primary" size="2rem" />
    </div>
  );
  const getTags = () => tagStore[tagType] ?? [];
  const getSelectedTags = () => tagStore.selectedTags[tagType] ?? [];

  const displayTagList = () => (
    <List
      data-testid="tags-list"
      // @ts-ignore
      className={classes.list}
    >
      {/* @ts-ignore */}
      {getTags().map((id: string) => {
        const tag: ITag = tagStore.tags[id];
        const isSelected: boolean = getSelectedTags().includes(tag);
        // render list points for active tags only
        if (!tag.active) return null;
        return (
          <ListItem
            role="listitem"
            className={classes.listItem}
            button
            key={tag.id}
            onClick={() => {
              selectTag(tag);
            }}
            selected={isSelected}
          >
            <ListItemText>
              <Typography noWrap style={{ fontSize: 14 }}>
                {tag.name}
              </Typography>
            </ListItemText>
            {isSelected && (
              <ListItemIcon className={classes.listIcon}>
                <CloseIcon style={{ fontSize: 16 }} />
              </ListItemIcon>
            )}
          </ListItem>
        );
      })}
    </List>
  );

  return (
    <Slide in={isOpen} direction="right">
      {isLoading ? displayCircularProgress() : displayTagList()}
    </Slide>
  );
};

export default TagDrawer;
